import { ButtonMain, Table } from '@quero-delivery/quero-components-web';
import { useNavigate } from 'react-router-dom';
import styles from './place-row.module.scss';
import type { PlacesOpen } from '../../types';
import { useAppDispatch } from '@/_store/hooks';
import { setSelectedPlaceToViewRules } from '@/_store/modules/places';

interface PlaceRowProps {
  place: PlacesOpen;
}

function PlaceRow({ place }: PlaceRowProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const selectPlace = () => {
    dispatch(
      setSelectedPlaceToViewRules({
        placeId: place._id,
        placeAvatarSrc: place.avatarSrc,
        placeName: place.placeName,
      }),
    );
  };

  return (
    <Table.Row className="pointer">
      <Table.Cell
        className={styles.rowName}
        onClick={() => navigate(`/estabelecimentos/${place._id}`)}
      >
        <img src={place.avatarSrc} height={20} alt="iconStatus" />
        {place.placeName}
      </Table.Cell>
      <Table.Cell textAlign="center">{place.deliveriesQuantity}</Table.Cell>
      <Table.Cell textAlign="center">{place.logDeliveriesQuantity}</Table.Cell>
      <Table.Cell textAlign="center">
        {place?.deliverymenAvailableQuantity || '- - -'}
      </Table.Cell>
      <Table.Cell textAlign="center">
        <div className={styles.buttonContainer}>
          <ButtonMain onClick={selectPlace} className={styles.buttonStyle}>
            configuração
          </ButtonMain>
        </div>
      </Table.Cell>
    </Table.Row>
  );
}

export { PlaceRow };
